var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "object-block-company", class: _vm.objectBlockClasses },
    [
      _c(
        "div",
        { staticClass: "object-block__header" },
        [
          _c(
            "div",
            { staticClass: "object-block__header-title-container" },
            [
              _c("CompassObject", {
                attrs: { object: _vm.objectType, size: _vm.objectSize }
              }),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "object-block__header-name-container" },
                  [
                    _c("BlockName", {
                      attrs: {
                        name: _vm.name,
                        link: !_vm.displayLink ? _vm.linkCard : null
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "CompassTooltip",
                      {
                        attrs: {
                          disabled: !_vm.typeLabel,
                          content: _vm.typeLabel,
                          arrow: false,
                          placement: "top"
                        }
                      },
                      [_c("DotThird", { attrs: { type: _vm.data.type } })],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                [
                  _vm.OBJECT_BLOCK_VARIANT.SIMPLE_PREVIEW,
                  _vm.OBJECT_BLOCK_VARIANT.SELECTION
                ].includes(_vm.variant)
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "typographies-paragraph-caps-small-regular object-block__header-caption"
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.objectCaption) +
                            "\n                "
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.displayLink
            ? _c("CompassLink", {
                attrs: {
                  label: _vm.linkLabel,
                  link: _vm.linkCard,
                  target: "_blank"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.displayActions
            ? _c(
                "div",
                { staticClass: "object-block__header-actions" },
                [
                  _c("CompassButton", {
                    attrs: {
                      type: "tertiary",
                      label: _vm.$t.__("common.actions.edit")
                    },
                    on: {
                      click: function($event) {
                        return _vm.$emit("edit")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("CompassButton", {
                    attrs: {
                      type: "tertiary",
                      label: _vm.$t.__("common.actions.unlink_object")
                    },
                    on: {
                      click: function($event) {
                        return _vm.$emit("unlink")
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.variant === _vm.OBJECT_BLOCK_VARIANT.LINKED
            ? _c("CompassIconButton", {
                attrs: { icon: "close" },
                on: {
                  click: function($event) {
                    return _vm.$emit("unlink")
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.displayDescriptionList && _vm.hasDescriptionListItem
        ? _c(
            "BlockDescriptionListPart",
            _vm._b({}, "BlockDescriptionListPart", _vm.$props, false)
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("contact")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }